module.exports = __webpack_public_path__ + "img/6.c0fc5732.jpg";